import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import { useBackHandler } from '@react-native-community/hooks';
import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import { Image, Text, View } from 'react-native';
import { SccPressable } from '@/components/SccPressable';
import ImageViewer from 'react-native-image-zoom-viewer';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import LeftArrowIcon from '@/assets/icon/ic_arrow_left.svg';
import { color } from '@/constant/color';
import { ImageType, SlideText, } from './PlaceDetailScreen/sections/PlaceDetailCoverImage.style';
const ImageZoomViewerScreen = ({ route }) => {
    const navigation = useNavigation();
    const safeAreaInsets = useSafeAreaInsets();
    const { imageUrls, index = 0, types = [], } = route.params;
    const [currentIndex, setCurrentIndex] = useState(index);
    useBackHandler(() => {
        navigation.goBack();
        return true;
    });
    return (_jsxs(_Fragment, { children: [_jsx(SccPressable, { elementName: "image_zoom_viewer_back_button", style: {
                    marginTop: safeAreaInsets.top,
                    position: 'absolute',
                    top: 14,
                    left: 20,
                    zIndex: 999,
                }, hitSlop: 10, onPress: () => navigation.goBack(), children: _jsx(LeftArrowIcon, { width: 24, height: 24, color: color.white }) }), _jsx(ImageViewer, { index: index, onSwipeDown: () => navigation.goBack(), renderIndicator: (idx, all) => {
                    return (_jsx(Text, { style: {
                            position: 'absolute',
                            bottom: safeAreaInsets.bottom,
                            width: '100%',
                            textAlign: 'center',
                            color: 'white',
                            fontSize: 14,
                            lineHeight: 16,
                        }, children: `${idx} / ${all}` }));
                }, onChange: i => setCurrentIndex(Number(i)), imageUrls: imageUrls.map((url) => {
                    return { url };
                }), renderImage: props => (_jsxs(View, { children: [_jsx(Image, Object.assign({}, props)), types.length > 0 && (_jsx(ImageType, { children: _jsx(SlideText, { children: types[currentIndex] }) }))] })) })] }));
};
export default ImageZoomViewerScreen;
